import { initializeFirebaseClient } from '#features/api/utils/firebase';
import { envConfig } from '#constants/envConfig';

/** FCM can fan out a foreground delivery to more than one open browser tab. */
export function watchWebForegroundNotifications(
  callback: (payload: Record<string, unknown>) => void
): () => void {
  if (
    envConfig.IS_NATIVE ||
    typeof window === 'undefined' ||
    typeof document === 'undefined' ||
    typeof Notification === 'undefined'
  ) {
    return () => undefined;
  }
  const client = initializeFirebaseClient();
  if (!client) return () => undefined;
  return client.watchForegroundMessages((payload) => {
    if (document.visibilityState !== 'visible') return;
    const data: Record<string, unknown> = { ...payload.data };
    if (typeof data.title !== 'string' || !data.title) data.title = payload.notification?.title;
    if (typeof data.body !== 'string' || !data.body) data.body = payload.notification?.body;
    if (typeof data.notificationId !== 'string' || !data.notificationId) {
      if (payload.messageId) data.notificationId = `fcm:${payload.messageId}`;
    }
    callback(data);
  });
}
